import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, unref as _unref, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bd93c10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-[54px]" }
const _hoisted_2 = { class: "px-3 mb-[40px]" }
const _hoisted_3 = { class: "border-[3px] border-[var(--secondary-color)] rounded-[100px] p-16 w-full" }
const _hoisted_4 = { class: "p-3 mb-[56px]" }
const _hoisted_5 = { class: "grid grid-cols-2 gap-x-[56px] p-3 mb-16" }
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = { class: "flex gap-x-[52px] mb-4" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  name: "excursion_name",
  type: "text",
  placeholder: "О чем молчат дворцы Васильевского острова",
  class: "edit bk",
  required: ""
}, null, -1))
const _hoisted_9 = { class: "flex gap-x-[52px] mb-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  name: "excursion_data",
  type: "date",
  placeholder: "01.03.2024",
  class: "edit bk",
  required: ""
}, null, -1))
const _hoisted_11 = { class: "flex gap-x-[52px] mb-4" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  name: "adult",
  type: "number",
  placeholder: "2",
  class: "edit bk",
  required: ""
}, null, -1))
const _hoisted_13 = { class: "flex gap-x-[52px] mb-4" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  name: "childs",
  type: "number",
  placeholder: "2",
  class: "edit bk"
}, null, -1))
const _hoisted_15 = { class: "flex flex-col" }
const _hoisted_16 = { class: "flex gap-x-[52px] mb-4" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  name: "fio",
  type: "text",
  placeholder: "Иванов Иван Иванович",
  class: "edit bk",
  required: ""
}, null, -1))
const _hoisted_18 = { class: "flex gap-x-[52px] mb-4" }
const _hoisted_19 = { class: "flex gap-x-[52px] mb-4" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  name: "email",
  type: "email",
  placeholder: "ivan.ivanov@mail.ru",
  class: "edit bk",
  required: ""
}, null, -1))
const _hoisted_21 = { class: "flex gap-x-[52px] mb-4" }
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "flex items-center gap-x-6 px-6 mb-16" }
const _hoisted_24 = { class: "flex justify-center" }

import { ref, reactive } from 'vue';
import { vMaska } from 'maska';
import BaseTypography from '@/components/common/BaseTypography.vue';
import BaseButton from '@/components/common/BaseButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

const options = { mask: '+7 (###) ###-##-##' };

const agreement = ref(false);
const form = reactive({
    phone: '',
});

const optionsSelect = [
    { value: 'Моб. связь', text: 'Моб. связь' },
    { value: 'Telegram', text: 'Telegram' },
    { value: 'WhatsApp', text: 'WhatsApp' },
    { value: 'Эл. почта', text: 'Эл. почта' },
];

const selectedOption = ref(optionsSelect[0].value);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BaseTypography, {
        text: "Бронирование экскурсии",
        type: "subtitle"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(BaseTypography, {
          text: "Бронирование",
          type: "subtitle"
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createVNode(BaseTypography, {
            text: "Общая информация",
            type: "special-body",
            class: "mb-[46px]"
          }),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", null, [
                _createVNode(BaseTypography, {
                  text: "Название экскурсии*",
                  type: "special-body2",
                  class: "w-[200px]"
                })
              ]),
              _hoisted_8
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", null, [
                _createVNode(BaseTypography, {
                  text: "Дата экскурсии*",
                  type: "special-body2",
                  class: "w-[200px]"
                })
              ]),
              _hoisted_10
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("label", null, [
                _createVNode(BaseTypography, {
                  text: "Количество взрослых*",
                  type: "special-body2",
                  class: "w-[200px]"
                })
              ]),
              _hoisted_12
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("label", null, [
                _createVNode(BaseTypography, {
                  text: "Количество детей",
                  type: "special-body2",
                  class: "w-[200px]"
                })
              ]),
              _hoisted_14
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _createVNode(BaseTypography, {
            text: "Обратная связь",
            type: "special-body",
            class: "mb-[46px]"
          }),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("label", null, [
                _createVNode(BaseTypography, {
                  text: "ФИО*",
                  type: "special-body2",
                  class: "w-[200px]"
                })
              ]),
              _hoisted_17
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("label", null, [
                _createVNode(BaseTypography, {
                  text: "Номер телефона*",
                  type: "special-body2",
                  class: "w-[200px]"
                })
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.phone) = $event)),
                placeholder: "+7(000)000-00-00",
                name: "phone",
                type: "text",
                class: "edit bk",
                required: ""
              }, null, 512), [
                [_vModelText, form.phone],
                [_unref(vMaska), void 0, options]
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("label", null, [
                _createVNode(BaseTypography, {
                  text: "Электронная почта",
                  type: "special-body2",
                  class: "w-[200px]"
                })
              ]),
              _hoisted_20
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("label", null, [
                _createVNode(BaseTypography, {
                  text: "Способ связи",
                  type: "special-body2",
                  class: "w-[200px]"
                })
              ]),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedOption).value = $event)),
                class: "edit bk"
              }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(optionsSelect, (option) => {
                  return _createElementVNode("option", {
                    key: option.value,
                    value: option.value
                  }, _toDisplayString(option.text), 9, _hoisted_22)
                }), 64))
              ], 512), [
                [_vModelSelect, selectedOption.value]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", {
          class: _normalizeClass(["h-10 w-10 bg-[var(--base-white)] border-[4px] border-[--primary-color] rounded-full cursor-pointer", { 'border-[4px] !border-[--secondary-color]': agreement.value }]),
          onClick: _cache[2] || (_cache[2] = () => (agreement.value = !agreement.value))
        }, null, 2),
        _createElementVNode("div", null, [
          _createVNode(BaseTypography, {
            text: "Я согласен(а) на обработку персональных данных на условиях, изложенных в ",
            type: "caption",
            tag: "span"
          }),
          _createVNode(_component_router_link, { to: "/consent" }, {
            default: _withCtx(() => [
              _createVNode(BaseTypography, {
                text: "Согласии на обработку персональных данных ",
                type: "caption",
                class: "underline",
                tag: "span"
              })
            ]),
            _: 1
          }),
          _createVNode(BaseTypography, {
            text: "и ",
            type: "caption",
            tag: "span"
          }),
          _createVNode(_component_router_link, { to: "/policy" }, {
            default: _withCtx(() => [
              _createVNode(BaseTypography, {
                text: "Политике.",
                type: "caption",
                class: "underline",
                tag: "span"
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createVNode(BaseButton, {
          text: "Забронировать",
          type: "subtitle4",
          color: "var(--base-white)",
          ui: "primary-with-back",
          class: "cursor-pointer"
        })
      ])
    ])
  ]))
}
}

})